import styled from 'styled-components';
import * as Comp from './components/MainNav';

export const MainNav = styled(Comp.MainNav)``;
export interface MainNavProps extends Comp.MainNavProps {}
